import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { useSelector } from "react-redux";
import '../../../assets/AdButtonGroup.css';
import amazon from "../../../assets/images/amazon.png";
import adwords from "../../../assets/images/adwords.png";
import facebook from "../../../assets/images/facebook.png";
import tiktok from "../../../assets/images/tik-tok.png";
import amazonads from "../../../assets/images/amazon-ads.png";
import linkedin from "../../../assets/images/linkedin.webp";

const AdButton = ({ image, alt, label, isSelected, onSelect, disabled }) => (
    <button
        className={`ad-button ${isSelected ? 'ad-button-selected' : ''}`}
        onClick={onSelect}
        disabled={disabled}
        style={{
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
        }}
    >
        <img src={image} alt={alt} />
        <span>{label}</span>
    </button>
);

const AdButtonGroup = ({ onButtonSelect, selectedButton }) => {
    const [internalSelectedButton, setInternalSelectedButton] = useState(selectedButton);

    // Redux'tan featureFlags verisini çekiyoruz
    const featureFlags = useSelector(state => state.getPermissionsList.subscriptions.find(sub => sub.subscriptionType === "DMP_DSP_EXPORT")?.featureFlags || {});

    const buttons = [
        { image: amazon, label: "AdForm - S3", alt: "Amazon", disabled: !featureFlags.ad_form },
        { image: adwords, label: "Google Ads", alt: "Google Ads", disabled: !featureFlags.google },
        { image: facebook, label: "Meta Ads", alt: "Meta Ads", disabled: !featureFlags.meta },
        { image: tiktok, label: "TikTok Ads", alt: "TikTok Ads", disabled: !featureFlags.tiktok },
        { image: linkedin, label: "LinkedIn Ads", alt: "LinkedIn Ads", disabled: !featureFlags.linkedin },
        { image: amazonads, label: "Amazon Ads", alt: "Amazon Ads", disabled: !featureFlags.amazon },
    ];

    // Kullanıcının yetkisi olan ilk butonu seçiyoruz
    useEffect(() => {
        const firstEnabledButtonIndex = buttons.findIndex(button => !button.disabled);
        if (firstEnabledButtonIndex !== -1) {
            setInternalSelectedButton(firstEnabledButtonIndex);
            onButtonSelect(firstEnabledButtonIndex);
        } else {
            // Eğer hiçbir buton aktif değilse, -1 ile belirtiyoruz
            setInternalSelectedButton(-1);
        }
    }, []);

    const handleSelect = (buttonIndex) => {
        if (!buttons[buttonIndex].disabled) {
            setInternalSelectedButton(buttonIndex);
            onButtonSelect(buttonIndex);
        }
    };

    return (
        <Row className="ad-button-group">
            {buttons.map((button, index) => (
                <Col key={index} lg={2} className="ad-button-column">
                    <AdButton
                        image={button.image}
                        alt={button.alt}
                        label={button.label}
                        isSelected={internalSelectedButton === index}
                        onSelect={() => handleSelect(index)}
                        disabled={button.disabled}
                    />
                </Col>
            ))}
            {internalSelectedButton === -1 && (
                <Col lg={12}>
                    <p className="text-center text-danger">You do not have permissions to use any of the platforms.</p>
                </Col>
            )}
        </Row>
    );
};

export default AdButtonGroup;
